import React, { createContext, PropsWithChildren } from "react";
import cssVars from "css-vars-ponyfill";

export type ThemeValue = {
  "--color-primary"?: string;
  "--color-primary-dark"?: string;
  "--color-primary-reverse"?: string;
  "--color-disabled"?: string;
  "--color-warning"?: string;
  "--color-warning-light"?: string;
  "--background-color"?: string;
  "--body-background-color"?: string;
  "--font-color"?: string;
  "--font-color-secondary"?: string;
  "--font-color-tertiary"?: string;
  "--border-color"?: string;
  "--btn-color"?: string;
  "--btn-shadow-primary"?: string;
  "--mask-color"?: string;
  "--btn-color-disabled"?: string;
};

export type ThemeProviderProps = {
  value: ThemeValue & { [key: string]: string };
  scoped?: boolean;
};

const createTheme = (theme: { [key: string]: string }) => {
  return createContext({ ...theme });
};

export const ThemeContext = createTheme({});

const ThemeProvider: React.FC<PropsWithChildren<ThemeProviderProps>> = ({
  children,
  value,
  scoped = false,
}) => {
  let clonedElement = children;
  if (!scoped) {
    Object.keys(value).forEach(key => {
      document.body.style.setProperty(key, value[key]);
    });
  } else {
    clonedElement = React.Children.map(children, (child, index) => {
      if (index === 0) {
        return React.cloneElement(child as any, {
          style: value,
        });
      } else {
        return child;
      }
    });
  }

  cssVars({
    variables: value as { [key: string]: string },
  });

  return (
    <ThemeContext.Provider value={value}>{clonedElement}</ThemeContext.Provider>
  );
};

export default ThemeProvider;
